import React, {useState, useEffect, useContext} from 'react';
import { Col, Container, Row, Card, Button, Modal, Dropdown, Image, Alert} from 'react-bootstrap';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useSelector} from 'react-redux';
import axios from '../../backendClient'
import { useNavigate, useLocation } from 'react-router-dom';
import { AppContext } from '../../AppContext';
import Eventcard from './Eventcard';
import Categories from '../categories/Categories';


const Listing = () => {


   
    const navigate = useNavigate(); 
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
     // This will hold whether there's more data to load
    const [hasMore, setHasMore] = useState(true);
    const [error, setError] = useState('');
    const [showError, setShowError] = useState(true);
    const [loading, setLoading] = useState(false); 
    const {currentUser} = useSelector(state => state.user);
    const socket = useContext(AppContext); 
    const [category, setCategory] = useState(''); 
    const [pageFlip, setPageFlip] = useState(true); 

    const {search} = useLocation(); 

    const queryParams = new URLSearchParams(search); 
    const query = queryParams.get('query'); 
    

    //This will be passed in to the mongodb search query 
    const handleCategory = (categoryVar) => {
        setCategory(categoryVar); 
    }


      // This function will be called when the user scrolls down
    const fetchMoreData = async () => {
        //compare fetchedData(people) to data
        //continue to request more and setFetchedData
        //otherwise do the check below and the db will have been 
        //exhausted
      if(loading){
        return; 
      }

      setLoading(true); 

      try{
        let response; 
        if(!currentUser){
            response = await axios.get(`/api/events/getPublicFacingEvents?page=${page}&&category=${category}`);
        }
        else{
            response = await axios.get(`/api/events/getPublicEvents?page=${page}&&category=${category}`);
        }
       
        const newData = response.data; 
        if (newData.length === 0) {
            setHasMore(false);
            return;
        }else{
          setData(prevData => [...prevData, ...newData ]);
          setPage(prevPage => prevPage +1);
        }
      }
      catch(e){
        setError(e.response.data.message);
      } finally{
        setLoading(false); 
      }
    };

    // Initial data load
    useEffect(() => {
        fetchMoreData(); 
        //alert(query); 
        
    }, [pageFlip]);

    useEffect(() => {

        setPage(1);
        setData([]);
  
      }, []);
  
      useEffect(() => {
  
        setPage(1);
        setData([]);
        setPageFlip(!pageFlip); 
  
      }, [category]);

    
    const handleShow = () => {
      navigate('/event'); 
    }

    //tracking clicks for dashboard with a visible card or not on Offers and Listings 
    const [visibleCard, setVisibleCard] = useState(null);

    //pass in an id for the Offer to set it's details as visible in EventCard component 
    const toggleCardVisibility = (id) => {
      if(visibleCard === id){
        setVisibleCard(null);
      }else{
      setVisibleCard(id);}
    };
   
  return (
    <Container className='maincontainer py-5'>
        <Row>
            {error && showError && <Alert variant="danger" onClose={() => {setShowError(false);}} dismissible>{error}</Alert>}
        </Row>
        <Row className="mb-3 justify-content-between">
          <Col xs="auto" className="d-flex align-items-center justify-content-between">
            <Categories setSelectedCategory={handleCategory} />
            <Button onClick={handleShow} className="px-1 py-1 btn btn-outline-purple rounded m-1">
              + Post Offer
            </Button>
            </Col>
        </Row>
            <h1 className='text-center mb-3'>Promotions in Your City</h1>
        <InfiniteScroll
            dataLength={data.length}
            next={fetchMoreData}
            hasMore={hasMore}
            loader={<h4>Loading...</h4>}
            endMessage={ data.length > 0 && 
            <p style={{textAlign: 'center'}}>
                <b>Yay! You have seen it all</b>
            </p>
            }
        > 

            <Row>
                {data.length === 0 && !hasMore ? (
                <Col className='d-flex justify-content-center align-items-center' style={{minHeight: '50vh'}}>
                    <h4>Looks like there's no offers for this criteria in your area! <br/> Create one in My Offers...</h4>
                </Col>):
                (data.map((event, i) => (
                    <Eventcard key={i} data={event} isVisible={visibleCard===event._id} toggleVisibility={()=> toggleCardVisibility(event._id)} />
                ))
                )}
            </Row>
        </InfiniteScroll> 
    </Container>
  )
}

export default Listing 